// extracted by mini-css-extract-plugin
export default {"root":"PortfolioView_root__qMqxu","header":"PortfolioView_header__d0wDf","close":"PortfolioView_close__j+xqe","menu":"PortfolioView_menu__8S-GO","body":"PortfolioView_body__L+5II"};